import { Button } from '@material-ui/core';
import React, { Component } from 'react';
//import EventImg from '../../assets/images/yoga.png';
//import Calendar from '../../assets/images/schedule_black_24dp.svg';
//import Online_svg from '../../assets/images/desktop_windows_black_24dp.svg';

//import AppUtils from '../../apputils';
const img_path = 'https://www.kinshipliving.com/images/uploads/kinship/events/';
const img_path2 = 'https://www.kinshipliving.com/images/uploads/kinship/organizers/';

export default class EventDetailsPage extends Component {
    // constructor(props) {
    //     super(props)

    // }


    // HandleRouting = (route) => {
    //     AppUtils.HandlePageClick(this.props.componentprops, route)
    // }


    render() {
        return (

            <div class="event-details-main">

                <div class="container-fluid">

  {
    this.props.mystate.eventName !== '' ?

  

                    <div class="row">
                        <div class="col-md-12 col-lg-12">

                            <div class="event-details-heading">
                                <h2>{this.props.mystate.eventName}</h2>
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-12">
                            <div class="row">
                                <div class="col-md-8 col-lg-8">
                                    <div class="event-details-image">
                                        <img src={img_path + this.props.mystate.eventImage} alt="loading..." />
                                    </div>
                                </div>
                                <div class="col-md-4 col-lg-4">
                                    <div class="event-details-div">
                                        <div class="event-details-div-one">
                                            <h4>{this.props.mystate.eventDate}</h4>
                                            <h6>{this.props.mystate.eventTime} IST</h6>
                                            <p>Free for kinship members</p>
                                        </div>
                                        <div class="event-details-div-two">
                                            <span>
                                            </span>
                                        </div>
                                        <div class="event-details-div-three" style={{display:'flex'}}>
                                        <div>
                                            <div style={{ display: 'flex' }}>
                                                <i class="fa fa-desktop" aria-hidden="true"></i>
                                                <p>{this.props.mystate.eventMode} session</p>
                                            </div>
                                            <div style={{ display: 'flex' }}>
                                                <i class="fa fa-clock-o" aria-hidden="true"></i>
                                                <p>{this.props.mystate.eventDuration} minutes</p>
                                            </div>
                                            </div>
                                            <div style={{position:'absolute', right:'0'}}>
                                            <div style={{ display: 'flex' }}>
                                            <i class="fa fa-language" aria-hidden="true"></i>
                                            <p>{this.props.mystate.eventLanguage}</p>
                                        </div>
                                       
                                        <div class="event-details-lower-div-seats-info">
                                        <p>{this.props.mystate.eventLeftSeats} seats left</p>
                                    </div>
                                        
                                        </div>
                                        </div>
                                        {   this.props.LeftTime(this.props.mystate.eventStarDateTime) > 0 ?
                                            this.props.mystate.eventJoinStatus ?
                                            <div class="event-details-div-four">
                                            <Button type="button" class="btn" style={{cursor:'not-allowed'}} disabled="true"
                                               // onClick={() => this.props.JoinEvent()}
                                            >Already Registered</Button>
                                        </div>
                                        :
                                            <div class="event-details-div-four">
                                            <Button type="button" class="btn"
                                                onClick={() => this.props.JoinEvent()}
                                            >Book Session</Button>
                                        </div>
                                       :
                                    
                                   '' }
                                       
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="col-md-8 col-lg-8">
                            <div class="event-details-lower-div">
                                <div class="row">
                                
                                    <div class="col-md-12 col-lg-12">
                                        <div class="event-details-lower-div-head">
                                            <h4>Join us for {this.props.mystate.eventName}</h4>
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-12">
                                        <div class="event-details-lower-div-content">
                                        <h4>About the Session</h4>
                                            <p>{this.props.mystate.eventDesc}</p>
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-lg-12">
                                    <div class="event-details-lower-div-content">
                                    <h4>
                                    About the instructor
                                    </h4>
                                    </div>
                                    </div>
                                <div class="col-md-6 col-lg-6">
                                <div class="card organizer-info-div">
                                
                               
                                <div class="event-details-lower-div-organizer-pic">
                                <img src={img_path2+this.props.mystate.eventOrganizerPic.replace(',', '')} alt='loading...'/>
                            </div>
                               
                               
                                <div class="event-details-lower-div-organizer-info">
                                <p>{this.props.mystate.eventOrganizerName}</p>
                           
                                </div>
                                <div className='event-details-lower-div-organizer-info'>
                                <a onClick={()=>this.props.HandleRouting(`organizer-details/${this.props.mystate.eventOrganizerId}`)}>View Profile</a>
                                </div>
                                </div>
                                </div>
                           
                                </div>
                            </div>
                        </div>
                    </div>
                                    :''}
                </div>
            </div>
        )
    }
}